/* Maliha Beauty 2026 — gentle Wava floating chat lift on retail mobile.
   Runs only in the unpublished Kalles redesign. Does not change app settings.
   The Shopify Draft preview toolbar is outside the store and will not be
   visible to actual shoppers. Lift is deliberately modest (32 CSS pixels).
*/
(() => {
  "use strict";
  if (window.matchMedia("(min-width: 750px)").matches) return;

  const lift = "0 -32px";
  const match = '[id*="wava" i], [class*="wava" i], [data-app*="wava" i], [id*="whatsapp" i], [class*="whatsapp" i], [title*="whatsapp" i], [aria-label*="whatsapp" i], iframe[src*="wava" i]';
  let done = false;

  function position() {
    if (done || window.innerWidth >= 750 || document.body?.classList.contains("hdt-page-type-page")) return;
    const sw = window.innerWidth;
    const sh = window.innerHeight;

    for (const el of document.querySelectorAll(match)) {
      let node = el;
      for (let depth = 0; node && depth < 7; depth++, node = node.parentElement) {
        if (!(node instanceof HTMLElement)) continue;
        if (window.getComputedStyle(node).position !== "fixed") continue;
        const box = node.getBoundingClientRect();

        // Only the compact floating chat widget near the lower-right corner.
        // Do not shift site navigation, popup dialogs, chat panels, or other apps.
        if (box.width < 28 || box.width > 150 || box.height < 28 || box.height > 150) continue;
        if (box.right < sw - 125 || box.left < sw * .50) continue;
        if (box.bottom < sh - 165 || box.top > sh + 25) continue;

        node.style.setProperty("translate", lift, "important");
        node.dataset.malihaWavaLift = "true";
        done = true;
        return;
      }
    }
  }

  function initialize() {
    position();
    if (done || !document.body) return;
    const observer = new MutationObserver(() => {
      position();
      if (done) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => { observer.disconnect(); position(); }, 12000);
    window.setTimeout(position, 600);
    window.setTimeout(position, 2200);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
